import React from 'react';
import { Route, Switch } from 'react-router';
import type { FunctionComponent } from 'react';
import type { ComponentRouting, Routes } from 'core/routing/types';
import RenderRoute from './render-route';
import PageNotFound from 'core/components/not-found';

export interface RouteRendererProps {
  routes: Routes | null;
  componentRouting: ComponentRouting;
}

const RoutesRenderer: FunctionComponent<RouteRendererProps> = ({ routes, componentRouting }) => {
  if (!routes) return null;

  return (
    <Switch>
      {Object.entries(routes).map(([key, route]) => (
        <Route
          key={route.path}
          path={route.path}
          exact={route.exact}
          children={(props) => <RenderRoute Component={componentRouting[key]} route={route} {...props} />}
        />
      ))}
      <Route>
        <PageNotFound />
      </Route>
    </Switch>
  );
};

export default RoutesRenderer;
